import React from 'react';
import './NotFoundView.scss';
import { LANDING_PAGE_ROUTE, PORTAL_ROUTE } from 'config/route-consts';
import { useTranslation } from 'react-i18next';

function NotFoundView() {
  const [translate] = useTranslation();

  const handleClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    window.location.href = PORTAL_ROUTE;
  };

  const handleBackLanding = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    window.location.href = LANDING_PAGE_ROUTE;
  };

  return (
    <div className="error-page">
      <div className="logo"></div>
      <h1 className="error-page__title mt-5">
        {translate('notFound.title.notFound')}
      </h1>
      <p className="error-page__content mt-5">
        {translate('notFound.content.pleaseContact')}
        <a
          href="mailto:servicedesk@maisonrmi.com"
          className="error-page__contact"
        >
          {' servicedesk@maisonrmi.com '}
        </a>
        {translate('notFound.content.forAssistance')}
      </p>

      <div className="error-page__actions mt-5">
        <button className="btn mr-2" onClick={handleClick}>
          <span>
            <i className="tio-back_ui"></i> Go Back
          </span>
        </button>
        <button className="btn mr-2" onClick={handleBackLanding}>
          <span>
            <i className="tio-back_ui"></i> Back to Landing Page
          </span>
        </button>
      </div>
    </div>
  );
}

export default NotFoundView;
